"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/BYFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_38)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_38`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.23999 0H35.76V24H-0.23999V0Z",
					fill: "#007C30"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.23999 16.1404H35.76V0H-0.23999",
					fill: "#CE1720"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.77755 16.1404V0H-0.23999V24H35.76H6.77755V16.1404Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M1.72493 11.2L0.363525 8.99649L1.72493 6.83508L3.07931 8.99649L1.72493 11.2ZM4.85475 11.2L3.50037 8.99649L4.85475 6.83508L6.21616 8.99649L4.85475 11.2ZM1.72493 16.9263L0.363525 14.7228L1.72493 12.5614L3.07931 14.7228L1.72493 16.9263ZM4.85475 16.9263L3.50037 14.7228L4.85475 12.5614L6.21616 14.7228L4.85475 16.9263Z",
					fill: "#CE1720"
				}),
				/* @__PURE__ */ n("path", {
					d: "M1.72492 5.17891L0.595093 3.35435L1.72492 1.55786L2.84772 3.35435L1.72492 5.17891ZM4.85474 5.17891L3.73193 3.35435L4.85474 1.55786L5.98457 3.35435L4.85474 5.17891ZM1.72492 22.3158L0.595093 20.4842L1.72492 18.6877L2.84772 20.4842L1.72492 22.3158ZM4.85474 22.3158L3.73193 20.4842L4.85474 18.6877L5.98457 20.4842L4.85474 22.3158Z",
					stroke: "#CE1720",
					strokeWidth: .491228
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_38`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as BYFlag };
